// extracted by mini-css-extract-plugin
module.exports = {"titleText":"AskAdmin_titleText__3Cd9Z","textText":"AskAdmin_textText__1yczR"};